import React, { useEffect, useState } from "react";
import { Alert, Card, CardBody, Col, Row } from "reactstrap";

//import images
import OverviewTab from "./OverviewTab";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { getPerson as onGetPerson } from "slices/thunks";
import { createSelector } from "reselect";

const Content = ({ personId }: { personId: string }) => {
  const dispatch: any = useDispatch();

  const [activeTab, setActiveTab] = useState<any>("1");
  const toggleTab = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  useEffect(() => {
    if (personId)
      dispatch(
        onGetPerson({
          id: personId,
        })
      );
  }, [personId, dispatch]);

  const selectProperties = createSelector(
    (state: any) => state.Persons,
    (state) => ({
      person: state.person,
    })
  );
  const { person } = useSelector(selectProperties);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          {person?.classifiedInformation &&
            person?.classifiedInformation?.length > 0 && (
              <Alert color="warning" className="material-shadow">
                <strong> Classified Information! </strong> There are classified
                information available for this person. Please review the
                classified information section below for more information.
              </Alert>
            )}
          {/* {isDebarred && (
            <Alert color="danger" className="material-shadow">
              <strong> Suspended or Debarred! </strong> This contractor has been
              debarred by a UN Agency. Review the performance rating section
              below for more information.
            </Alert>
          )} */}
          <Card className="">
            <div className="bg-warning-subtle">
              <CardBody className="pb-0 px-4">
                <Header person={person} />
              </CardBody>
            </div>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <OverviewTab person={person} toggleTab={toggleTab} />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Content;
